'use strict';
import angular from 'angular';

import forbiddenHtmlUrl from '../../../views/shared/forbiddenPage.html';

angular.module('forbidden', [])

    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('forbiddenPage', {
                parent: 'loginlayout',
                url: '/forbiddenPage',
                templateUrl: forbiddenHtmlUrl
            })
    }]);